import { render, staticRenderFns } from "./ArticleMaterialAdmin.vue?vue&type=template&id=35fa6fc9&scoped=true"
import script from "./ArticleMaterialAdmin.vue?vue&type=script&lang=js"
export * from "./ArticleMaterialAdmin.vue?vue&type=script&lang=js"
import style0 from "./ArticleMaterialAdmin.vue?vue&type=style&index=0&id=35fa6fc9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fa6fc9",
  null
  
)

export default component.exports